import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { DateUtils } from '../../utils/DateUtils';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';

export const AsOfDate = () => {

  const { asOfDate, setAsOfDate, hist, entityFormMode } = useEntityMgr();

  const handleChange = (value) => {
    if (!value) {
      setAsOfDate(null);
      return;
    }

    const localDate = value.format('YYYY-MM-DDTHH:mm');
    const utcDate = DateUtils.convertLocalToUtc(localDate);
    setAsOfDate(utcDate);
  }

  const value = useMemo(() => {
    if (!asOfDate) return null;

    const localDate = DateUtils.convertUtcToLocal(asOfDate);
    const dayjsObject = dayjs(localDate);
    return dayjsObject;
  }, [asOfDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        disabled={hist || entityFormMode !== EntityFormMode.VIEW}
        label="As of Date"
        slotProps={{
          textField: {
            variant: 'standard'

            , inputProps: {
              'data-test-id': 'as-of-date',
            },
          },
          actionBar: {
            actions: ['clear'],
          },
        }}
        value={value}
        onChange={handleChange}
      />
    </LocalizationProvider>
  )
}